import { ColorTokens, DividerSizeTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, SizeTypeTokens, StackAlignItems, StackJustifyContent, StackType, StackWidth, WIDGET } from "@voltmoney/schema";
import { ROUTE } from "../../routes";
import { ACTION } from "../partnerWeb_Dashboard/types";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { StoreKey } from "../../configs/api";
import { showInviteAndEarnTab } from "../../configs/utils";
import { showCompletedApplications, showDashboard, showPendingApplications } from "../../configs/uri-config-utils";
import { getReferredPartnerMobileNavTitle } from "../partnerWeb_Dashboard/utils";
export const BottomNavBuilderDS = async (routeId) => {
    const _user = JSON.parse(await AsyncStorage.getItem(StoreKey.userContext));
    const partnerAccountType = _user?.linkedPartnerAccounts[0]?.partnerAccountType;
    const DS = {
        BottomNavContainer: {
            width: StackWidth.MATCH_PARENT,
            type: StackType.column,
            justifyContent: StackJustifyContent.spaceBetween,
            widgetItems: [
                { id: 'BottomNavDivider', type: WIDGET.DIVIDER },
                { id: 'BottomNavChildContainer', type: WIDGET.STACK },
            ]
        },
        BottomNavDivider: {
            size: DividerSizeTokens.SM,
            color: ColorTokens.Grey_Chalk
        },
        BottomNavChildContainer: {
            width: StackWidth.MATCH_PARENT,
            type: StackType.row,
            justifyContent: StackJustifyContent.spaceAround,
            padding: {
                top: SizeTypeTokens.LG,
                bottom: SizeTypeTokens.LG,
                left: SizeTypeTokens.XL,
                right: SizeTypeTokens.XL
            },
            widgetItems: [
                showDashboard(_user) ? { id: 'DashboardContainerBN', type: WIDGET.STACK } : {},
                showPendingApplications(_user) ? { id: 'LeadsContainerBN', type: WIDGET.STACK } : {},
                showCompletedApplications(_user) ? { id: 'ActiveCustomerContainerBN', type: WIDGET.STACK } : {},
                showInviteAndEarnTab(partnerAccountType, _user) ? { id: 'ReferredPartnerContainerBN', type: WIDGET.STACK } : {},
            ]
        },
        DashboardContainerBN: {
            type: StackType.column,
            alignItems: StackAlignItems.center,
            widgetItems: [
                { id: 'dashBoardStackIconBN', type: WIDGET.ICON },
                { id: 'space0BN', type: WIDGET.SPACE },
                { id: 'dashboardStackTextBN', type: WIDGET.TEXT },
            ],
            action: {
                routeId: routeId,
                type: ACTION.CHANGE_TAB,
                payload: {
                    value: 'dashboardLegacy',
                    widgetId: 'renderWidgetGroup',
                    route: ROUTE.PARTNER_DASHBOARD_V2,
                },
            },
        },
        dashBoardStackIconBN: {
            name: IconTokens.Grid_View,
            color: routeId === ROUTE.PARTNER_DASHBOARD_V2 || routeId === ROUTE.PLATFORM_DASHBOARD ? ColorTokens.Primary_100 : ColorTokens.Grey_Charcoal,
            size: IconSizeTokens.LG
        },
        dashboardStackTextBN: {
            label: 'DASHBOARD',
            fontFamily: FontFamilyTokens.Inter,
            fontSize: FontSizeTokens.XXS,
            fontWeight: '400',
            lineHeight: 16,
            color: routeId === ROUTE.PARTNER_DASHBOARD_V2 || routeId === ROUTE.PLATFORM_DASHBOARD ? ColorTokens.Primary_100 : ColorTokens.Grey_Charcoal
        },
        LeadsContainerBN: {
            type: StackType.column,
            alignItems: StackAlignItems.center,
            widgetItems: [
                { id: 'leadStackIconBN', type: WIDGET.ICON },
                { id: 'space1BN', type: WIDGET.SPACE },
                { id: 'leadStackTextBN', type: WIDGET.TEXT },
            ],
            action: {
                routeId: routeId,
                type: ACTION.CHANGE_TAB,
                payload: {
                    value: 'leadPage',
                    widgetId: 'renderWidgetGroup',
                    route: ROUTE.PARTNER_LEAD || ROUTE.PLATFORM_LEADS,
                },
            },
        },
        leadStackIconBN: {
            name: IconTokens.Lead2,
            color: routeId === ROUTE.PARTNER_LEAD || routeId === ROUTE.PLATFORM_LEADS ? ColorTokens.Primary_100 : ColorTokens.Grey_Charcoal,
            size: IconSizeTokens.LG
        },
        leadStackTextBN: {
            label: 'PENDING',
            fontFamily: FontFamilyTokens.Inter,
            fontSize: FontSizeTokens.XXS,
            fontWeight: '400',
            lineHeight: 16,
            color: routeId === ROUTE.PARTNER_LEAD || routeId === ROUTE.PLATFORM_LEADS ? ColorTokens.Primary_100 : ColorTokens.Grey_Charcoal
        },
        ActiveCustomerContainerBN: {
            type: StackType.column,
            alignItems: StackAlignItems.center,
            widgetItems: [
                { id: 'activeCustomerStackIconBN', type: WIDGET.ICON },
                { id: 'space2BN', type: WIDGET.SPACE },
                { id: 'activeCustomerStackTextBN', type: WIDGET.TEXT },
            ],
            action: {
                routeId: routeId,
                type: ACTION.CHANGE_TAB,
                payload: {
                    value: 'activeCustomerPage',
                    widgetId: 'renderWidgetGroup',
                    route: ROUTE.PARTNER_ACTIVE_CUSTOMER || ROUTE.PLATFORM_ACTIVE_CUSTOMERS,
                },
            },
        },
        activeCustomerStackIconBN: {
            name: IconTokens.Leads,
            color: routeId === ROUTE.PARTNER_ACTIVE_CUSTOMER || routeId === ROUTE.PLATFORM_ACTIVE_CUSTOMERS ? ColorTokens.Primary_100 : ColorTokens.Grey_Charcoal,
            size: IconSizeTokens.LG
        },
        activeCustomerStackTextBN: {
            label: 'COMPLETED',
            fontFamily: FontFamilyTokens.Inter,
            fontSize: FontSizeTokens.XXS,
            fontWeight: '400',
            lineHeight: 16,
            color: routeId === ROUTE.PARTNER_ACTIVE_CUSTOMER || routeId === ROUTE.PLATFORM_ACTIVE_CUSTOMERS ? ColorTokens.Primary_100 : ColorTokens.Grey_Charcoal
        },
        ReferredPartnerContainerBN: {
            type: StackType.column,
            alignItems: StackAlignItems.center,
            widgetItems: [
                { id: 'referredPartnerStackIconBN', type: WIDGET.ICON },
                { id: 'space3BN', type: WIDGET.SPACE },
                { id: 'referredPartnerStackTextBN', type: WIDGET.TEXT },
            ],
            action: {
                routeId: routeId,
                type: ACTION.CHANGE_TAB,
                payload: {
                    value: 'referredPartnerPage',
                    widgetId: 'renderWidgetGroup',
                    route: ROUTE.PARTNER_REFERRED_PARTNER,
                },
            },
        },
        referredPartnerStackIconBN: {
            name: IconTokens.Gift2,
            color: routeId === ROUTE.PARTNER_REFERRED_PARTNER ? ColorTokens.Primary_100 : ColorTokens.Grey_Charcoal,
            size: IconSizeTokens.LG
        },
        referredPartnerStackTextBN: {
            label: await getReferredPartnerMobileNavTitle(),
            fontFamily: FontFamilyTokens.Inter,
            fontSize: FontSizeTokens.XXS,
            fontWeight: '400',
            lineHeight: 16,
            color: routeId === ROUTE.PARTNER_REFERRED_PARTNER ? ColorTokens.Primary_100 : ColorTokens.Grey_Charcoal
        },
        space0BN: {
            size: SizeTypeTokens.Size6
        },
        space1BN: {
            size: SizeTypeTokens.Size6
        },
        space2BN: {
            size: SizeTypeTokens.Size6
        },
        space3BN: {
            size: SizeTypeTokens.Size6
        },
    };
    return DS;
};
